// extracted by mini-css-extract-plugin
module.exports = {"about":"_3c68b8","aboutInner":"_997cf1","aboutVideoWrap":"_18c419"};